module.exports = __webpack_public_path__ + "static/img/5.8b1d95f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/5.png
// module id = bQaU
// module chunks = 0